const kaiping3Role2 = {
  contentBg: 'https://qncweb.ktvsky.com/20251212/vadd/45b6f3d154e2dfe8594c8b5e103562e7.png',
  newCloseImg: 'https://qncweb-back1.ktvsky.com/20240828/vadd/e9baccf14ec131a5c998945763e685f5.png',
  newCloseType: true,
  closeClassName: 'top-right-close-new',
  showAgreementText: true,
  limitClose: true,
  isBottomType: true,
  className: 'bottom_big',
  isBottomPosition: true,
  selectIndex: 1,
  isMonthDiscount: true,
  tagContentNew: ['', '优惠5元', ''],
  isShowGiveFriend: true,
  page_tp: 'kaiping3_yzs',
  giveFriendConfig: {
    color: '#E91759',
    bg: 'https://qncweb.ktvsky.com/20251212/vadd/c769b89e87d4eddfb78a2fc5405ab42d.png',
    point: 'https://qncweb.ktvsky.com/20251212/vadd/e68c7161f329fd6267872c0f9cd6e869.png',
    leftPosition: '10vw',
    leftSelected: '4vw',
  },
  propStyleVar: {
    raiseWight: '100vw',
    maskColor: '#00000099',
    fontColor: {
      normal: ['#000000', '#999999', '#00000099'],
      selected: ['#000000', '#999999', '#00000099'],
    },
    packageBg: 'url(https://qncweb.ktvsky.com/20251212/vadd/a017763f6be2d6459cc45d0822634ba1.png)',
    packageBgSelected: 'url(https://qncweb.ktvsky.com/20251212/vadd/7a13b32e85bd4de76ca214f47cd44320.png)',
    timeTipBg: '#E91759',
    tagBg: '#E91759',
    monthColorSpan: '#FF134A',
    buttonHeight: '20vw',
    handTop: '54vw',
    handUrl: 'https://qncweb.ktvsky.com/20250923/vadd/4a59e3650f8a048b2329641f074d9b01.png',
    agreementTextColor: 'rgba(255, 255, 255, 0.4)',
  },
}

export {
  kaiping3Role2,
}
